export default function LocalDate({
  value,
  options,
}: {
  value: string;
  options?: Intl.DateTimeFormatOptions;
}) {
  return <>{new Date(value).toLocaleDateString(undefined, options)}</>;
}
